<template>
  <div class="mb-6 border-b border-border-subtle pb-6">
    <UiMonitorStepper
      :steps="stepperSteps"
      orientation="horizontal" />
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue'
import type { IMonitorStep } from '@team-milva/lab-components'

export default {
  name: 'ModalStepGuide',

  props: {
    stepTitles: {
      type: Array as PropType<string[]>,
      required: true,
    },
    currentStep: {
      type: Number,
      required: true,
    },
  },

  computed: {
    stepperSteps(): IMonitorStep[] {
      return this.stepTitles.map((title, index) => ({
        title,
        state:
          index + 1 < this.currentStep
            ? 'completed'
            : index + 1 === this.currentStep
              ? 'current'
              : 'pending',
      }))
    },
  },
}
</script>
